"use client";

import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import LocationIcon from "assets/svg/location_icon.svg";
import ListIcon from "assets/svg/icon_list.svg";

import { setMapOrListingFinalPath } from "src/helpers/map/commons";

import styles from "./styles.module.css";

const MapSwitchButton = ({ url }) => {
  const [selected, setSelected] = useState("listing");

  const handleSwitch = (tabKey) => {
    setSelected(tabKey);
    window.location.href = setMapOrListingFinalPath({ res: url, screenType: tabKey });
  };

  useEffect(() => {
    const url = window.location.href;
    const isMapView = url.includes("view_type=map");
    if (isMapView) {
      setSelected("map");
    } else {
      setSelected("listing");
    }
  }, []);

  const switchContainerClass = classNames(
    styles.switchContainer,
    { [styles.listSelected]: selected === "listing" },
    { [styles.mapSelected]: selected === "map" }
  );

  const switchClass = classNames(styles.switch, { [styles.mapSelectedSwitch]: selected === "map" });

  const leftSideClass = classNames(styles.leftSide, { [styles.listSelectedSide]: selected === "listing" });

  const rightSideClass = classNames(styles.rightSide, { [styles.mapSelectedSide]: selected === "map" });

  return (
    <div className={switchContainerClass}>
      <div className={switchClass}></div>
      <div className={leftSideClass} onClick={() => handleSwitch("listing")}>
        <ListIcon className={styles.icon} />
        Liste
      </div>
      <div className={rightSideClass} onClick={() => handleSwitch("map")}>
        <LocationIcon className={styles.icon} />
        Harita
      </div>
    </div>
  );
};

MapSwitchButton.propTypes = {
  url: PropTypes.any,
};

export default MapSwitchButton;
